import { render, staticRenderFns } from "./TOCTemp5.vue?vue&type=template&id=92869382&scoped=true&"
import script from "./TOCTemp5.vue?vue&type=script&lang=js&"
export * from "./TOCTemp5.vue?vue&type=script&lang=js&"
import style0 from "./TOCTemp5.vue?vue&type=style&index=0&id=92869382&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92869382",
  null
  
)

export default component.exports